import React from "react";

export default function TextInput({
  type = "text",
  label = "",
  placeholder = "",
  name = "",
  value,
  maxLength,
  onChange = () => {},
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "=") {
      e.preventDefault();
    }
  };

  return (
    <>
      <label className="mb-2.5 block font-medium text-black dark:text-white">
        {label || placeholder}
      </label>
      <div className="relative">
        <input
          autoComplete="off"
          type={type}
          name={name}
          value={value}
          maxLength={maxLength}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="w-full py-3 pl-6 pr-10 bg-transparent border rounded-lg outline-hidden placeholder:text-slate-500 border-stroke focus:border-brand focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-brand"
        />
      </div>
    </>
  );
}
